import { render } from "./ContentblockLatestNews.vue?vue&type=template&id=dd94cf92&scoped=true"
import script from "./ContentblockLatestNews.vue?vue&type=script&lang=js"
export * from "./ContentblockLatestNews.vue?vue&type=script&lang=js"

import "./ContentblockLatestNews.vue?vue&type=style&index=0&id=dd94cf92&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd94cf92"]])

export default __exports__